import { decamelize } from '@backmarket/utils/string/decamelize'

export const formatDataQaAttribute = (componentType: string) =>
  `cms-${decamelize(componentType, { separator: '-' })}`
